import type { Variants, Transition } from "framer-motion";

/**
 * Centralized animation configuration.
 *
 * All framer-motion variants + easings live here so motion stays consistent
 * and tunable from one place. Components import named variants rather than
 * declaring inline motion objects.
 */

/** Signature easing — a refined easeOutExpo used across the site. */
export const EASE = [0.22, 1, 0.36, 1] as const;
export const EASE_IN_OUT = [0.83, 0, 0.17, 1] as const;

export const DURATION = {
  fast: 0.35,
  base: 0.6,
  slow: 0.9,
  xslow: 1.2,
} as const;

export const baseTransition: Transition = {
  duration: DURATION.base,
  ease: EASE,
};

/** Fade + rise. Default section entrance. */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: baseTransition },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: baseTransition },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.94 },
  visible: { opacity: 1, scale: 1, transition: baseTransition },
};

/** Container that staggers its children on reveal. */
export const staggerContainer = (stagger = 0.08, delay = 0): Variants => ({
  hidden: {},
  visible: {
    transition: { staggerChildren: stagger, delayChildren: delay },
  },
});

/** Masked line reveal — used for the kinetic hero headline. */
export const maskLineParent: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

export const maskLineChild: Variants = {
  hidden: { y: "110%" },
  visible: {
    y: "0%",
    transition: { duration: DURATION.slow, ease: EASE },
  },
};

/** Word-by-word reveal for smaller kinetic phrases. */
export const wordChild: Variants = {
  hidden: { opacity: 0, y: "0.6em" },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE } },
};

/** Default viewport config for scroll-triggered reveals. */
export const viewportOnce = { once: true, amount: 0.25 } as const;

//added by sudip
export function fadeInUp(
    delay = 0,
    y = 24
): Variants {

    return {

        hidden: {
            opacity: 0,
            y,
        },

        visible: {
            opacity: 1,
            y: 0,
            transition: {
                ...baseTransition,
                delay,
            },
        },

    };

}
